/* LOEVA — script unique du theme. v2026-10-27
   Un seul garde : ce fichier est charge une fois par le layout. */
(function () {
  if (window.__msBooted) return;
  window.__msBooted = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- devise ---------------------------------------------------------
     /cart.js ne renvoie que des centimes. Le format vient du <body>, avec
     deux replis : l attribut de la section, puis un symbole nu. */
  function fmt() {
    var b = document.body;
    return (b && b.dataset && b.dataset.msMoney) || (window.MS_MONEY || '') || '{{amount}}';
  }
  function money(cents) {
    var f = fmt();
    var v = (cents / 100).toFixed(2);
    var ent = v.split('.')[0], dec = v.split('.')[1];
    var sep = ent.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = f
      .replace(/\{\{\s*amount\s*\}\}/g, sep + '.' + dec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sep)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, ent.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, ent.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    return out === f ? '£' + sep + '.' + dec : out;
  }
  window.msMoney = money;

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---- tiroir de navigation ------------------------------------------ */
  function nav() {
    var d = $('[data-ms-nav]');
    if (!d) return;
    var ouvre = function () { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var ferme = function () { d.classList.remove('is-open'); document.body.style.overflow = ''; };
    $$('[data-ms-nav-open]').forEach(function (b) { b.addEventListener('click', ouvre); });
    $$('[data-ms-nav-close]', d).forEach(function (b) { b.addEventListener('click', ferme); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ferme(); });
  }

  /* ---- accordeons ----------------------------------------------------- */
  function accordeons(racine) {
    $$('[data-ms-ac]', racine || document).forEach(function (b) {
      if (b.__ms) return; b.__ms = 1;
      b.addEventListener('click', function () {
        var i = b.closest('.ms-ac__i');
        var o = i.classList.toggle('on');
        b.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
    });
  }

  /* ---- onglets des tissus --------------------------------------------- */
  function tissus() {
    $$('[data-ms-fb]').forEach(function (bloc) {
      var bts = $$('[data-ms-fb-tab]', bloc);
      var cartes = $$('[data-ms-fb-carte]', bloc);
      bts.forEach(function (b, i) {
        b.addEventListener('click', function () {
          bts.forEach(function (x, k) { x.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
          cartes.forEach(function (c, k) { c.hidden = k !== i; });
        });
      });
    });
  }

  /* ---- galerie produit ------------------------------------------------ */
  function galerie() {
    var g = $('[data-ms-gal]');
    if (!g) return;
    var rail = $('[data-ms-gal-rail]', g);
    var dots = $('[data-ms-gal-dots]', g);
    if (!rail) return;

    function visibles() { return $$('.ms-g__slide', rail).filter(function (s) { return !s.hidden; }); }

    function majDots() {
      var v = visibles(); if (!v.length) return;
      var pos = rail.scrollLeft;
      var i = 0, ecart = Infinity;
      v.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - rail.offsetLeft - pos); if (d < ecart) { ecart = d; i = k; } });
      if (dots) {
        dots.innerHTML = v.map(function (_, k) { return '<span class="' + (k === i ? 'on' : '') + '"></span>'; }).join('');
      }
      v.forEach(function (s, k) {
        var vi = s.querySelector('video');
        if (!vi) return;
        if (k === i) { vi.play().catch(function () { }); } else { try { vi.pause(); } catch (e) { } }
      });
    }
    rail.addEventListener('scroll', function () {
      clearTimeout(rail.__t); rail.__t = setTimeout(majDots, 90);
    });

    function glisser(sens) {
      var v = visibles(); if (!v.length) return;
      var pos = rail.scrollLeft, i = 0, ecart = Infinity;
      v.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - rail.offsetLeft - pos); if (d < ecart) { ecart = d; i = k; } });
      var c = v[Math.max(0, Math.min(v.length - 1, i + sens))];
      if (c) rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
    }
    var p = $('[data-ms-gal-prev]', g), n = $('[data-ms-gal-next]', g);
    if (p) p.addEventListener('click', function () { glisser(-1); });
    if (n) n.addEventListener('click', function () { glisser(1); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var t = e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA') return;
      if ($('.ms-box.is-open')) return;
      glisser(e.key === 'ArrowRight' ? 1 : -1);
    });

    /* filtrage par coloris */
    window.msGalerie = function (plage) {
      var tous = $$('.ms-g__slide', rail);
      var rang = 10;
      tous.forEach(function (s) {
        if (s.dataset.video === '1') return;
        var i = +s.dataset.i;
        var dans = !plage || (i >= plage[0] && i <= plage[1]);
        s.hidden = !dans;
        if (dans) { s.style.order = rang; rang += 10; }
      });
      /* la video se place en 2e, comme sur la source */
      var vs = $('[data-ms-gal-video]', rail);
      if (vs && !vs.hidden) vs.style.order = 15;
      tous.forEach(function (s) {
        if (!s.hidden) return;
        var vi = s.querySelector('video');
        if (vi) { try { vi.pause(); } catch (e) { } }
      });
      rail.scrollTo({ left: 0, behavior: 'auto' });
      majDots();
    };
    majDots();
  }

  /* ---- fiche produit : coloris, lot, achat ---------------------------- */
  function produit() {
    var p = $('[data-ms-prod]');
    if (!p) return;
    var DATA = window.MS_PROD || {};
    var variantes = DATA.variants || [];
    var plages = DATA.plages || null;
    var videos = DATA.videos || {};
    var textes = DATA.tissuTextes || {};

    var etat = { variante: variantes[0], qty: 1, palier: 1, seconde: null, cadeau: 0 };

    function parId(id) { for (var i = 0; i < variantes.length; i++) if (variantes[i].id === id) return variantes[i]; return null; }

    function majVideo(nom) {
      var s = $('[data-ms-gal-video]');
      if (!s) return;
      var url = videos[nom];
      var v = s.querySelector('video');
      if (!url || !v) { s.hidden = true; return; }
      s.hidden = false;
      s.style.order = 15;
      if (v.dataset.src !== url) {
        v.dataset.src = url; v.src = url;
        var po = (DATA.posters || {})[nom];
        if (po) v.poster = po;
        v.load();
      }
    }

    function majColoris() {
      var v = etat.variante; if (!v) return;
      $$('[data-ms-swatch]', p).forEach(function (b) {
        var on = b.dataset.msSwatch === v.option1;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        var gr = b.closest('.ms-c__gr');
        if (gr && on) {
          $$('.ms-c__gr', p).forEach(function (g) { g.classList.remove('on'); });
          gr.classList.add('on');
        }
      });
      var nom = $('[data-ms-color-nom]', p); if (nom) nom.textContent = v.option1;
      var t = $('[data-ms-tissu-txt]', p);
      if (t) {
        var tis = (DATA.tissuDe || {})[v.option1] || '';
        t.innerHTML = textes[tis] || '';
      }
      if (plages && plages[v.option1] && window.msGalerie) window.msGalerie(plages[v.option1]);
      majVideo(v.option1);
      majPrix();
    }

    function prixPalier() {
      return etat.palier === 2 ? (DATA.lotCents || 0) : (etat.variante ? etat.variante.price : 0);
    }

    function majPrix() {
      var v = etat.variante; if (!v) return;
      var now = $('[data-ms-prix]', p), was = $('[data-ms-barre]', p);
      if (now) now.textContent = money(v.price);
      if (was) was.textContent = v.compare_at_price ? money(v.compare_at_price) : '';
      var b = $('[data-ms-add-prix]', p);
      if (b) b.textContent = 'Add to Cart — ' + money(prixPalier() * (etat.palier === 2 ? 1 : etat.qty));
      var sp = $('[data-ms-sticky-prix]');
      if (sp) sp.innerHTML = money(prixPalier()) + (v.compare_at_price ? '<s>' + money(etat.palier === 2 ? (DATA.lotBarreCents || v.compare_at_price * 2) : v.compare_at_price) + '</s>' : '');
    }

    /* coloris */
    $$('[data-ms-swatch]', p).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parId(+b.dataset.msId);
        if (v) { etat.variante = v; majColoris(); }
      });
    });

    /* quantite */
    var qa = $('[data-ms-qty-moins]', p), qp = $('[data-ms-qty-plus]', p), qv = $('[data-ms-qty]', p);
    function majQty() { if (qv) qv.textContent = etat.qty; majPrix(); }
    if (qa) qa.addEventListener('click', function () { etat.qty = Math.max(1, etat.qty - 1); majQty(); });
    if (qp) qp.addEventListener('click', function () { etat.qty = Math.min(20, etat.qty + 1); majQty(); });

    /* paliers du lot */
    var secBloc = $('[data-ms-seconde]', p);
    $$('[data-ms-palier]', p).forEach(function (b) {
      b.addEventListener('click', function () {
        etat.palier = +b.dataset.msPalier;
        $$('[data-ms-palier]', p).forEach(function (x) { x.classList.toggle('on', x === b); });
        if (secBloc) secBloc.hidden = etat.palier !== 2;
        var q = $('[data-ms-qty-bloc]', p);
        if (q) q.hidden = etat.palier === 2;
        majPrix();
      });
    });
    $$('[data-ms-cadeau]', p).forEach(function (b) {
      b.addEventListener('click', function () {
        etat.cadeau = +b.dataset.msCadeau;
        $$('[data-ms-cadeau]', p).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        var n = $('[data-ms-cadeau-nom]', p);
        if (n) n.textContent = b.dataset.msNom || '';
      });
    });

    $$('[data-ms-sec]', p).forEach(function (b) {
      b.addEventListener('click', function () {
        etat.seconde = +b.dataset.msSec;
        $$('[data-ms-sec]', p).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        var n = $('[data-ms-sec-nom]', p);
        if (n) n.textContent = b.dataset.msNom || '';
      });
    });

    /* ajout au panier */
    function ajoute() {
      var v = etat.variante; if (!v) return;
      var lignes = [];
      if (etat.palier === 2) {
        var s = etat.seconde ? parId(etat.seconde) : null;
        if (!s) {
          var prem = $('[data-ms-sec]', p);
          if (prem) { prem.click(); s = parId(+prem.dataset.msSec); }
        }
        if (!s) return;
        if (s.id === v.id) lignes.push({ id: v.id, quantity: 2 });
        else { lignes.push({ id: v.id, quantity: 1 }); lignes.push({ id: s.id, quantity: 1 }); }
        /* la piece offerte part dans le meme ajout : c est la remise automatique
           « 2 achetes, 1 offert » qui la ramene a zero, jamais le theme. */
        var cad = etat.cadeau || DATA.cadeau;
        if (cad) lignes.push({ id: cad, quantity: 1 });
      } else {
        lignes.push({ id: v.id, quantity: etat.qty });
      }
      var bt = $('[data-ms-add]', p);
      if (bt) bt.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lignes })
      }).then(function (r) { return r.json(); })
        .then(function () { return panierCharge(); })
        .then(function () { panierOuvre(); })
        .catch(function () { })
        .then(function () { if (bt) bt.disabled = false; });
    }
    $$('[data-ms-add]').forEach(function (b) { b.addEventListener('click', ajoute); });

    /* barre collante : visible seulement quand le bouton du haut est DEPASSE */
    var sticky = $('[data-ms-sticky]');
    var ancre = $('[data-ms-add]', p);
    if (sticky && ancre) {
      var maj = function () {
        var r = ancre.getBoundingClientRect();
        sticky.hidden = r.bottom > 0;
      };
      window.addEventListener('scroll', maj, { passive: true });
      window.addEventListener('resize', maj);
      maj();
    }

    majColoris();
    majQty();
  }

  /* ---- panier --------------------------------------------------------- */
  var PANIER = null;

  function panierCharge() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { PANIER = c; panierPeint(); return c; })
      .catch(function () { });
  }
  function panierOuvre() { var d = $('[data-ms-cart]'); if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function panierFerme() { var d = $('[data-ms-cart]'); if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; } }

  function panierPeint() {
    var c = PANIER; if (!c) return;
    var cmp = window.MS_COMPARE || {};
    $$('[data-ms-cart-n]').forEach(function (e) { e.textContent = c.item_count; });
    var titre = $('[data-ms-cart-titre]'); if (titre) titre.textContent = 'Cart: ' + c.item_count;
    var body = $('[data-ms-cart-body]');
    if (body) {
      if (!c.items.length) {
        body.innerHTML = '<div class="ms-cart__vide">Your cart is empty. Add a MoonPillow, cover, or Little Moon to get started.</div>';
      } else {
        body.innerHTML = c.items.map(function (it, i) {
          var barre = cmp[it.variant_id] ? '<s>' + money(cmp[it.variant_id] * it.quantity) + '</s>' : '';
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
          return '<div class="ms-cart__l">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" fetchpriority="low">' : '<span></span>') +
            '<div><div class="ms-cart__t">' + esc(it.product_title) + '</div>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="ms-cart__o">' + esc(it.variant_title) + '</div>' : '') +
            '<div class="ms-cart__r"><div class="ms-cart__q">' +
            '<button type="button" data-ms-moins="' + (i + 1) + '" aria-label="Decrease">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-ms-plus="' + (i + 1) + '" aria-label="Increase">+</button></div>' +
            '<div class="ms-cart__pr">' + barre + money(it.final_line_price) + '</div></div>' +
            '<button type="button" class="ms-cart__del" data-ms-del="' + (i + 1) + '">Remove</button>' +
            '</div></div>';
        }).join('');
      }
    }
    var eco = $('[data-ms-cart-eco]');
    if (eco) {
      var d = c.total_discount || 0;
      eco.hidden = d <= 0;
      var v = $('[data-ms-cart-eco-v]'); if (v) v.textContent = '-' + money(d);
    }
    var st = $('[data-ms-cart-total]'); if (st) st.textContent = money(c.total_price);
    var go = $('[data-ms-cart-go]');
    if (go) go.classList.toggle('off', c.item_count === 0);
    var up = $('[data-ms-cart-up]');
    if (up) up.hidden = c.item_count !== 1;
  }

  function panierChange(ligne, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: ligne, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { PANIER = c; panierPeint(); })
      .catch(function () { });
  }

  function panier() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-ms-cart-open],[data-ms-cart-close],[data-ms-moins],[data-ms-plus],[data-ms-del]') : null;
      if (!t) return;
      if (t.hasAttribute('data-ms-cart-open')) { e.preventDefault(); panierCharge().then(panierOuvre); return; }
      if (t.hasAttribute('data-ms-cart-close')) { e.preventDefault(); panierFerme(); return; }
      var l;
      if ((l = t.getAttribute('data-ms-moins'))) { var it = PANIER.items[+l - 1]; panierChange(+l, Math.max(0, it.quantity - 1)); return; }
      if ((l = t.getAttribute('data-ms-plus'))) { var i2 = PANIER.items[+l - 1]; panierChange(+l, i2.quantity + 1); return; }
      if ((l = t.getAttribute('data-ms-del'))) { panierChange(+l, 0); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panierFerme(); });
    panierCharge();
  }

  /* ---- visionneuse ---------------------------------------------------- */
  function visionneuse() {
    var box = $('[data-ms-box]');
    if (!box) return;
    var jeu = [], idx = 0;
    var img = $('[data-ms-box-img]', box), leg = $('[data-ms-box-leg]', box), cpt = $('[data-ms-box-cpt]', box);
    function peint() {
      var m = jeu[idx]; if (!m) return;
      img.innerHTML = m.video
        ? '<video src="' + esc(m.video) + '" controls playsinline autoplay></video>'
        : '<img src="' + esc(m.src) + '" alt="">';
      if (leg) leg.textContent = m.leg || '';
      if (cpt) cpt.textContent = (idx + 1) + ' / ' + jeu.length;
    }
    function ouvre(liste, i) { jeu = liste; idx = i; box.classList.add('is-open'); document.body.style.overflow = 'hidden'; peint(); }
    function ferme() { box.classList.remove('is-open'); document.body.style.overflow = ''; img.innerHTML = ''; }
    window.msBox = ouvre;
    $$('[data-ms-box-x],[data-ms-box-voile]', box).forEach(function (b) { b.addEventListener('click', ferme); });
    var pv = $('[data-ms-box-prev]', box), nx = $('[data-ms-box-next]', box);
    if (pv) pv.addEventListener('click', function () { idx = (idx - 1 + jeu.length) % jeu.length; peint(); });
    if (nx) nx.addEventListener('click', function () { idx = (idx + 1) % jeu.length; peint(); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') ferme();
      if (e.key === 'ArrowLeft' && pv) pv.click();
      if (e.key === 'ArrowRight' && nx) nx.click();
    });
  }

  /* ---- avis ----------------------------------------------------------- */
  function avis() {
    var bloc = $('[data-ms-avis]');
    if (!bloc) return;
    var tous = window.MS_AVIS || [];
    var media = window.MS_MEDIA || {};
    var liste = $('[data-ms-avis-liste]', bloc);
    var bouton = $('[data-ms-avis-plus]', bloc);
    var vus = 0, PAS = 5;

    function etoiles(n) {
      var s = '';
      for (var i = 0; i < 5; i++) {
        s += '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.9 15.04 8.06 21.84 9.05 16.92 13.84 18.08 20.61 12 17.42 5.92 20.61 7.08 13.84 2.16 9.05 8.96 8.06 12 1.9Z" fill="' + (i < n ? '#ffb15f' : '#e2e8f0') + '" stroke="' + (i < n ? '#ffb15f' : '#e2e8f0') + '" stroke-width="1.2" stroke-linejoin="round"></path></svg>';
      }
      return '<div class="ms-et">' + s + '</div>';
    }
    function dateFr(iso) {
      var d = new Date(iso);
      var m = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return m[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }
    function photos(r) {
      var ms = (r.media || []).filter(function (m) { return media[m]; });
      if (!ms.length) return '';
      var trois = ms.slice(0, 3);
      return '<div class="ms-av__ph">' + trois.map(function (m, i) {
        var plus = (i === 2 && ms.length > 3) ? '<span class="ms-av__plus"><b>+' + (ms.length - 3) + '</b></span>' : '';
        return '<button type="button" data-ms-ph="' + esc(r.id) + '" data-ms-i="' + i + '"><img src="' + esc(media[m]) + '" alt="MoonPillow review from ' + esc(r.nom) + '" fetchpriority="low">' + plus + '</button>';
      }).join('') + '</div>';
    }
    function rendre() {
      var lot = tous.slice(vus, vus + PAS);
      liste.insertAdjacentHTML('beforeend', lot.map(function (r) {
        return '<article class="ms-av__i"><div>' + etoiles(r.note) +
          '<div class="ms-av__who"><p>' + esc(r.nom) + '</p>' + (r.verifie ? '<span>Verified Buyer</span>' : '') + '</div>' +
          '<p class="ms-av__date">' + dateFr(r.date) + '</p></div>' +
          '<div><h3>' + esc(r.titre) + '</h3><p>' + esc(r.texte) + '</p>' + photos(r) + '</div></article>';
      }).join(''));
      vus += lot.length;
      if (bouton) bouton.hidden = vus >= tous.length;
    }
    if (liste) rendre();
    if (bouton) bouton.addEventListener('click', rendre);

    bloc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ms-ph]');
      if (b) {
        var r = tous.filter(function (x) { return x.id === b.dataset.msPh; })[0];
        if (!r) return;
        var jeu = (r.media || []).filter(function (m) { return media[m]; }).map(function (m) { return { src: media[m], leg: r.nom }; });
        if (window.msBox) window.msBox(jeu, Math.min(+b.dataset.msI, jeu.length - 1));
        return;
      }
      var w = e.target.closest('[data-ms-mur]');
      if (w) {
        var ids = (window.MS_MUR || []);
        var jeu2 = ids.map(function (m) { return { src: media[m], leg: '' }; }).filter(function (x) { return x.src; });
        if (window.msBox) window.msBox(jeu2, +w.dataset.msMur || 0);
      }
    });
  }

  /* ---- infolettre ----------------------------------------------------- */
  function infolettre() {
    $$('[data-ms-nl]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        f.innerHTML = '<p style="font-size:14px;opacity:.85">Thank you. You are on the list.</p>';
      });
    });
  }

  function demarre() {
    nav(); accordeons(); tissus(); galerie(); produit(); panier(); visionneuse(); avis(); infolettre();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
})();
